import { memo } from 'react';
import { Checkbox } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { DotIcon } from '../dot-icon';

interface EmployeeItemProps {
  id: number;
  firstName: string;
  lastName: string;
  position?: string;
  checked: boolean;
  onToggle: (id: number) => void;
  isRemote: boolean;
}

export const EmployeeItem = memo(
  ({ id, firstName, lastName, position, checked, onToggle, isRemote }: EmployeeItemProps) => {
    return (
      <div {...stylex.props(styles.employeeContainer)} onClick={() => onToggle(id)}>
        <DotIcon />
        <div {...stylex.props(styles.employeeCheckbox)} onClick={(e) => e.stopPropagation()}>
          <Checkbox isChecked={checked} onChange={() => onToggle(id)} />
        </div>
        <div {...stylex.props(styles.employeeInfo)}>
          <div {...stylex.props(styles.employeeFullname)}>
            {firstName} {lastName}
            {isRemote && <span {...stylex.props(styles.remoteStatus)}>Удаленно</span>}
          </div>
          <div {...stylex.props(styles.employeePosition)}>{position}</div>
        </div>
      </div>
    );
  }
);
